<div class="rep-modal">

  <!-- Header -->
  <div class="rep-modal-header">
    <h5 class="rep-modal-title">Representation</h5>
       <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
      />
    </button>
  </div>

  <!-- Body -->
  <div class="rep-modal-body">
    <div class="rep-table-wrapper">
      <table class="rep-table">
        <thead>
          <tr>
            <th class="rep-label-cell" scope="col"></th>
            <th *ngFor="let item of currentPageData" class="rep-date-cell" scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <!-- Date row -->
          <tr>
            <td class="rep-label-cell">Date</td>
            <td *ngFor="let item of currentPageData" class="rep-date-cell">
              <ng-container *ngFor="let part of formatDate(item.date).split('\n'); let last = last">
                {{ part }}<br *ngIf="!last" />
              </ng-container>
            </td>
          </tr>
          <!-- Status row -->
          <tr>
            <td class="rep-label-cell">Status</td>
            <td *ngFor="let item of currentPageData" class="rep-status-cell">
              <app-status-badge [status]="item.status"></app-status-badge>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Footer / Pagination -->
  <div class="rep-modal-footer">
    <button class="rep-nav-btn" (click)="prevPage()" [disabled]="currentPage === 1">
      <span class="rep-nav-arrow">&#8592;</span> Prev
    </button>
    <span class="rep-page-info">
      Page <strong>{{ currentPage }}</strong> of {{ totalPages }}
    </span>
    <button class="rep-nav-btn" (click)="nextPage()" [disabled]="currentPage === totalPages">
      Next <span class="rep-nav-arrow">&#8594;</span>
    </button>
  </div>

</div>
